const e=Object.freeze({loose:!0}),o=Object.freeze({});var t=t=>t?"object"!=typeof t?e:t:o;export{t as p};
